/*! © 2026 AirX (airx.art). All rights reserved. Unauthorized copying, reproduction, or redistribution of this code is prohibited. Report infringement: info@airx.art */

(function () {
  'use strict';

  if (window.__airxAboutStoryInit) return;
  window.__airxAboutStoryInit = true;

  var ROUND_TO = 50;

  function finalText(el, value) {
    return value.toLocaleString() + (el.dataset.counterSuffix || '');
  }

  function retarget(el, value) {
    el.dataset.counter = String(value);

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;

    if (!el.dataset.motionInit || !gsap || !ScrollTrigger) {
      el.textContent = finalText(el, value);
      return;
    }

    ScrollTrigger.getAll().forEach(function (st) {
      if (st.trigger === el) {
        if (st.animation) st.animation.kill();
        st.kill();
      }
    });
    var state = { value: 0 };
    gsap.to(state, {
      value: value,
      duration: 1.6,
      ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 85%', once: true },
      onUpdate: function () {
        el.textContent = Math.round(state.value).toLocaleString() + (el.dataset.counterSuffix || '');
      },
    });
  }

  function applyLiveStats(root) {
    var els = root.querySelectorAll('[data-live-stat="reviews"]');
    if (!els.length) return;
    if (!window.AirXStats || typeof window.AirXStats.get !== 'function') return;
    window.AirXStats.get().then(function (stats) {
      if (!stats) return;
      var rounded = Math.floor(stats.count / ROUND_TO) * ROUND_TO;
      if (rounded < ROUND_TO) return;
      els.forEach(function (el) {
        retarget(el, rounded);
      });
    });
  }

  function init() {
    applyLiveStats(document);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        if (e.target && e.target.querySelectorAll) applyLiveStats(e.target);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
